module.exports = __webpack_public_path__ + "img/hxgyy.ef7660e.png";